import React from "react";
import Navbar from "../../components/main/navbar";
import Footer from "../../components/main/footer";
import validate from "../../images/payment-success.svg";
import { Button, Grid2, Typography } from "@mui/material";

const OfferSuccess = () => {
  return (
    <div>
      <div sx={{ minHeight: "100vh" }}>
        <Navbar />

        <Grid2>
          <Grid2 container justifyContent="space-evenly" padding="50px">
            <Grid2 xs={6}>
              <img
                src={`${validate}`}
                height="300px"
                width="350px"
                alt="Success!"
              />
            </Grid2>
            <Grid2 xs={6} width="500px" alignContent="center" spacing={2}>
              <Typography
                variant="h3"
                fontSize="20px"
                color="#146aff"
                flexWrap="wrap"
                display="flex"
              >
                {" "}
                Paiement effectué{" "}
              </Typography>

              <Typography variant="body2" color="#146aff">
                {" "}
                Votre paiement a été traité avec succès. Merci !{" "}
              </Typography>

              <Button
                href="/user/plan"
                type="submit"
                fullWidth
                variant="contained"
                sx={{
                  mt: 3,
                  mb: 2,
                  backgroundColor: "#146aff",
                  "&:hover": { backgroundColor: "#004aad" },
                }}
              >
                Votre plan
              </Button>
            </Grid2>
          </Grid2>
        </Grid2>
      </div>

      <Footer />
    </div>
  );
};

export default OfferSuccess;
